import useSWR from 'swr'
import { getCvFeedbackForJobOffer } from '../../../api/cv-roaster'

// Constants for cache keys
const CACHE_BASE = 'cv'
const CACHE_KEYS = {
  LAST_CV_FOR_OFFER: (jobOfferId: number) => `${CACHE_BASE}/offer${jobOfferId}`,
} as const

//
export const useCVForOffer = (jobOfferId?: number) => {
  return useSWR(
    jobOfferId ? CACHE_KEYS.LAST_CV_FOR_OFFER(jobOfferId) : null,
    jobOfferId ? () => getCvFeedbackForJobOffer(jobOfferId) : null
  )
}
